var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDateicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dateicon_svg",
    "data-name": "dateicon_svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1-dateicon {\r\n        fill: var(--input-text-color);\r\n      }\r\n\r\n      .cls-2-dateicon {\r\n        fill: var(--primary-color);\r\n        stroke: var(--primary-color);\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 28px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-dateicon",
    d: "M1666.36044,177.51074h-86.49311V33.35555h-144.1552V177.51074H484.28787V33.35555H340.13267V177.51074H253.63956c-119.23076,0-216.23279,97.002-216.23279,216.23279V1662.30922c0,119.2307,97.002,216.23278,216.23279,216.23278H1666.36044c119.2307,0,216.23279-97.00208,216.23279-216.23278V393.74353C1882.59323,274.51277,1785.59125,177.51074,1666.36044,177.51074Zm72.0776,1484.79848a72.15933,72.15933,0,0,1-72.0776,72.07759H253.63956a72.15936,72.15936,0,0,1-72.0776-72.07759V710.885H1738.438Zm0-1095.57946H181.562V393.74353a72.1594,72.1594,0,0,1,72.0776-72.0776h86.49311V465.82112h144.1552V321.66593h951.42426V465.82112h144.1552V321.66593h86.49311a72.15937,72.15937,0,0,1,72.0776,72.0776Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-dateicon",
    x: 311.30164,
    y: 862.2479,
    width: 144.15519,
    height: 144.15519
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-dateicon",
    x: 599.61202,
    y: 862.2479,
    width: 144.15519,
    height: 144.15519
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-dateicon",
    x: 887.9224,
    y: 862.2479,
    width: 144.15519,
    height: 144.15519
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-dateicon",
    x: 1176.23279,
    y: 862.2479,
    width: 144.15519,
    height: 144.15519
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-dateicon",
    x: 1464.54317,
    y: 862.2479,
    width: 144.15519,
    height: 144.15519
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-dateicon",
    x: 311.30164,
    y: 1150.55828,
    width: 144.15519,
    height: 144.15519
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-dateicon",
    x: 599.61202,
    y: 1150.55828,
    width: 144.15519,
    height: 144.15519
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-dateicon",
    x: 887.9224,
    y: 1150.55828,
    width: 144.15519,
    height: 144.15519
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-dateicon",
    x: 1176.23279,
    y: 1150.55828,
    width: 144.15519,
    height: 144.15519
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-dateicon",
    x: 311.30164,
    y: 1438.86867,
    width: 144.15519,
    height: 144.15519
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-dateicon",
    x: 599.61202,
    y: 1438.86867,
    width: 144.15519,
    height: 144.15519
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-dateicon",
    x: 887.9224,
    y: 1438.86867,
    width: 144.15519,
    height: 144.15519
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-dateicon",
    x: 1176.23279,
    y: 1438.86867,
    width: 144.15519,
    height: 144.15519
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-dateicon",
    x: 1464.54317,
    y: 1150.55828,
    width: 144.15519,
    height: 144.15519
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateicon);
export default __webpack_public_path__ + "static/media/dateicon.19e40d848f1485339ed261b88a714682.svg";
export { ForwardRef as ReactComponent };